module.exports = __webpack_public_path__ + "static/media/Teste.acfea4c5.pdf";